<template>
  <!-- Footer -->
  <footer class="text-center py-3">
    
  </footer>
</template>
<script setup></script>

<style scoped>
/* Footer Styling */
footer {
  margin-top: auto;
}
footer p {
  font-size: 1.1rem;
  font-weight: bold;
}
footer small {
  font-size: 0.9rem;
}
</style>
